import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch}                             from "react-redux";
import Order from "../../../interfaces/forms/Order";
import Filter from "../../../interfaces/forms/Filter";
import {ItemLoaders} from "../../../core/loaders/ItemLoaders";
import {FormGeneralHelper} from "../../../helpers/FormGeneral";
import {configDefault} from "../../../core/config";
import {REQUEST_STATE} from "../../../helpers/RequestHelper";
import {SystemLanguageCollectionInterface} from "../interfaces/SystemLanguageInterface";
import {SYSTEM_LANGUAGE_ACTIONS} from "../actions";
import {
    PlatformResellerAvailableLanguagesCollectionInterface
} from "../interfaces/PlatformResellerAvailableLanguagesInterface";

interface UseSystemLanguageInterface {
    getResellerLanguagesCallback: (filtersCallback?: Array<Filter>, ordersCallback?: Array<Order>) => void;
    resellerAvailableLanguagesCollection: PlatformResellerAvailableLanguagesCollectionInterface | null;
    state: number;
}

const useSystemLanguage = (filters: Array<Filter> = [], orders: Array<Order> = []): UseSystemLanguageInterface => {
    const dispatch = useDispatch();
    const [responseState, setResponseState] = useState<number>(REQUEST_STATE.IDLE);
    const [resellerAvailableLanguagesCollection, setResellerAvailableLanguagesCollection] = useState<PlatformResellerAvailableLanguagesCollectionInterface | null>(null);

    const getResellerLanguagesCallback = useCallback((filtersCallback?: Array<Filter>, ordersCallback?: Array<Order>): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_reseller_to_system_languages', configDefault.PLATFORM_API_PREFIX)),
            SYSTEM_LANGUAGE_ACTIONS.LIST,
            filtersCallback ?? filters,
            ordersCallback ?? orders,
            {
                onSuccess: (data: PlatformResellerAvailableLanguagesCollectionInterface) => {
                    setResellerAvailableLanguagesCollection(data);
                    setResponseState(REQUEST_STATE.IDLE)
                },
                onError: (error: any) => {
                    setResellerAvailableLanguagesCollection(null);
                    setResponseState(REQUEST_STATE.ERROR)
                }
            },
            {propagateDataToCallback: true, dispatchAfterCallback: false}
        );
    },[dispatch,orders,filters])

    useEffect(() => {
        if ((responseState !== REQUEST_STATE.PENDING && responseState !== REQUEST_STATE.ERROR) && !resellerAvailableLanguagesCollection) {
            setResponseState(REQUEST_STATE.PENDING);
            getResellerLanguagesCallback();
        }
    }, [dispatch, responseState,getResellerLanguagesCallback,resellerAvailableLanguagesCollection]);
    return {
        getResellerLanguagesCallback: getResellerLanguagesCallback,
        resellerAvailableLanguagesCollection: resellerAvailableLanguagesCollection,
        state: responseState
    };
};

export default useSystemLanguage;
